<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-stock-transfer-detail-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalStockTransferDetail"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-stock-transfer-detail-modal"
      data-bs-dismiss="modal"
      data-bs-target="#modalStockTransferDetail"
    ></button>
    <div id="custom-overlay" class="custom-modal-overlay"></div>
    <div
      class="modal fade"
      id="modalStockTransferDetail"
      tabindex="-1"
      aria-labelledby="modalStockTransferDetailLabel"
      aria-hidden="true"
      style="z-index: 1055"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div class="d-flex align-items-center">
              <h5 class="modal-title">Stock Transfer</h5>
              <div
                class="d-flex align-items-center"
                v-if="stockTransferDetail?.from || stockTransferDetail?.to"
              >
                <div class="mx-3">-</div>
                <h5 class="modal-title mb-0">
                  <span
                    v-if="stockTransferDetail?.from"
                    style="color: #007bff !important"
                    >From: {{ stockTransferDetail?.from }}</span
                  ><span
                    :class="stockTransferDetail?.from ? 'ms-3' : ''"
                    v-if="stockTransferDetail?.to"
                    style="color: #007bff !important"
                    >To: {{ stockTransferDetail?.to }}</span
                  >
                </h5>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div
                style="font-weight: bold"
                :style="{
                  color: stockTransferDetail?.status_color ?? '#007bff',
                }"
              >
                {{ stockTransferDetail?.status_label ?? "New" }}
              </div>
              <i
                style="cursor: pointer"
                class="material-icons justify-content-end ms-3"
                data-bs-dismiss="modal"
                aria-label="Close"
                >clear</i
              >
            </div>
          </div>
          <div class="modal-body mb-3">
            <h5 class="modal-title mt-1">
              Doc No: {{ fromStockMovement ? stockTransferDetail?.document_no : stockTransferDetail?.doc_no }}
            </h5>
            <div class="table-responsive p-0 custom-table mt-3">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-left font-weight-bolder"
                      v-for="(column, index) in columns"
                      :key="index"
                    >
                      {{ column }}
                    </th>
                  </tr>
                </thead>
                <tbody
                  v-if="
                    stockTransferDetail &&
                    stockTransferDetail.stock_transfer_items &&
                    stockTransferDetail.stock_transfer_items.length
                  "
                >
                  <tr
                    v-for="(
                      item, index
                    ) in stockTransferDetail.stock_transfer_items"
                    :key="index"
                  >
                    <td class="text-left text-xss w-20">
                      {{ fromStockMovement ? item?.item_no : item?.item?.item_no }}
                    </td>
                    <td class="text-left text-xss w-15">
                      {{ fromStockMovement ? item?.barcode : item?.item?.barcode }}
                    </td>
                    <td class="text-left text-xss w-35">
                      {{ fromStockMovement ? item?.item_name : item?.item?.item_name }}
                    </td>
                    <td class="text-left text-xss w-15">
                      {{ formatPrice(item?.unit_cost) }}
                    </td>
                    <td class="text-left text-xss w-15">
                      {{ item?.qty }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5" class="text-center">No item available</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer d-flex align-items-center justify-content-between" v-if="!fromStockMovement">
            <div class="d-flex export-type">
              <button
                class="dt-button buttons-html5 mb-0"
                type="button"
                @click="exportFile('csv')"
              >
                <span>Csv</span>
              </button>
              <button
                class="dt-button buttons-html5 mb-0"
                type="button"
                @click="exportFile('xlsx')"
              >
                <span>Excel</span>
              </button>
              <button
                class="dt-button buttons-html5 mb-0"
                type="button"
                @click="exportFile('pdf')"
              >
                <span>PDF</span>
              </button>
            </div>
            <div class="d-flex">
              <material-button
                v-if="stockTransferDetail?.status == STATUS_IN_TRANSIT"
                class="mx-2 btn btn-sm btn-background"
                @click="changeType('void')"
              >
                Void
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-background"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="editStockTransfer(stockTransferDetail?.id, stockTransferDetail?.stock_action, true)"
              >
                Duplicate
              </material-button>
              <material-button
                v-if="stockTransferDetail?.status == STATUS_IN_TRANSIT"
                class="mx-2 btn btn-sm btn-background"
                @click="changeType('receive')"
              >
                Receive
              </material-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrice } from "@/config/utils";
import MaterialButton from "@/components/MaterialButton.vue";
import { STATUS_IN_TRANSIT, STATUS_VOID } from "../mock_data";

export default {
  name: "ModalItemList",
  components: {
    MaterialButton,
  },
  props: {
    stockTransferDetail: {
      type: Object,
      required: true,
    },
    editStockTransfer: {
      type: Function,
      default: () => {},
    },
    changeType: {
      type: Function,
      default: () => {},
    },
    fromStockMovement: {
      type: Boolean,
      default: false,
    },
    exportFile: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      columns: ["Item No", "Barcode", "Item Name", "Unit Cost", "Qty"],
      STATUS_IN_TRANSIT,
      STATUS_VOID,
    };
  },
  methods: {
    formatPrice,
  }
};
</script>

<style scoped>
.modal-dialog {
  max-width: 1000px;
}

.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}

div.dt-button-info {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  margin-top: -100px;
  margin-left: -200px;
  background-color: white;
  border: 2px solid #111;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  text-align: center;
  z-index: 21;
}
div.dt-button-info h2 {
  padding: 0.5em;
  margin: 0;
  font-weight: normal;
  border-bottom: 1px solid #ddd;
  background-color: #f3f3f3;
}
div.dt-button-info > div {
  padding: 1em;
}
div.dt-button-collection-title {
  text-align: center;
  padding: 0.3em 0 0.5em;
  font-size: 0.9em;
}
div.dt-button-collection-title:empty {
  display: none;
}
button.dt-button {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  margin-right: 0.333em;
  margin-bottom: 0.333em;
  padding: 0.5em 1em;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  cursor: pointer;
  font-size: 0.88em;
  line-height: 1.6em;
  color: black;
  white-space: nowrap;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.1);
  background: -webkit-linear-gradient(
    top,
    rgba(230, 230, 230, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -moz-linear-gradient(
    top,
    rgba(230, 230, 230, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(230, 230, 230, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(230, 230, 230, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(230, 230, 230, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='rgba(230, 230, 230, 0.1)', EndColorStr='rgba(0, 0, 0, 0.1)');
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-decoration: none;
  outline: none;
  text-overflow: ellipsis;
}
button.dt-button.disabled {
  cursor: default;
  opacity: 0.4;
}
button.dt-button:active:not(.disabled),
button.dt-button.active:not(.disabled) {
  background-color: rgba(0, 0, 0, 0.1);
  background: -webkit-linear-gradient(
    top,
    rgba(179, 179, 179, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -moz-linear-gradient(
    top,
    rgba(179, 179, 179, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(179, 179, 179, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(179, 179, 179, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(179, 179, 179, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='rgba(179, 179, 179, 0.1)', EndColorStr='rgba(0, 0, 0, 0.1)');
  box-shadow: inset 1px 1px 3px #999999;
}
button.dt-button:active:not(.disabled):hover:not(.disabled),
button.dt-button.active:not(.disabled):hover:not(.disabled) {
  box-shadow: inset 1px 1px 3px #999999;
  background-color: rgba(0, 0, 0, 0.1);
  background: -webkit-linear-gradient(
    top,
    rgba(128, 128, 128, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -moz-linear-gradient(
    top,
    rgba(128, 128, 128, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(128, 128, 128, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(128, 128, 128, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(128, 128, 128, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='rgba(128, 128, 128, 0.1)', EndColorStr='rgba(0, 0, 0, 0.1)');
}
button.dt-button:hover {
  text-decoration: none;
}
button.dt-button:hover:not(.disabled) {
  border: 1px solid #666;
  background-color: rgba(0, 0, 0, 0.1);
  background: -webkit-linear-gradient(
    top,
    rgba(153, 153, 153, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -moz-linear-gradient(
    top,
    rgba(153, 153, 153, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(153, 153, 153, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(153, 153, 153, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(153, 153, 153, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='rgba(153, 153, 153, 0.1)', EndColorStr='rgba(0, 0, 0, 0.1)');
}
button.dt-button:focus:not(.disabled) {
  border: 1px solid #426c9e;
  text-shadow: 0 1px 0 #c4def1;
  outline: none;
  background-color: #79ace9;
  background: -webkit-linear-gradient(top, #d1e2f7 0%, #79ace9 100%);
  background: -moz-linear-gradient(top, #d1e2f7 0%, #79ace9 100%);
  background: -ms-linear-gradient(top, #d1e2f7 0%, #79ace9 100%);
  background: -o-linear-gradient(top, #d1e2f7 0%, #79ace9 100%);
  background: linear-gradient(to bottom, #d1e2f7 0%, #79ace9 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='#d1e2f7', EndColorStr='#79ace9');
}
div.dt-button-collection button.dt-button {
  position: relative;
  left: 0;
  right: 0;
  width: 100%;
  display: block;
  float: none;
  margin-bottom: 4px;
  margin-right: 0;
}
div.dt-button-collection button.dt-button:active:not(.disabled),
div.dt-button-collection button.dt-button.active:not(.disabled) {
  background-color: #dadada;
  background: -webkit-linear-gradient(top, #f0f0f0 0%, #dadada 100%);
  background: -moz-linear-gradient(top, #f0f0f0 0%, #dadada 100%);
  background: -ms-linear-gradient(top, #f0f0f0 0%, #dadada 100%);
  background: -o-linear-gradient(top, #f0f0f0 0%, #dadada 100%);
  background: linear-gradient(to bottom, #f0f0f0 0%, #dadada 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='#f0f0f0', EndColorStr='#dadada');
  box-shadow: inset 1px 1px 3px #666;
}
button.dt-button.processing {
  color: rgba(0, 0, 0, 0.2);
}
button.dt-button.processing:after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  box-sizing: border-box;
  display: block;
  content: " ";
  border: 2px solid #282828;
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;
  animation: dtb-spinner 1500ms infinite linear;
  -o-animation: dtb-spinner 1500ms infinite linear;
  -ms-animation: dtb-spinner 1500ms infinite linear;
  -webkit-animation: dtb-spinner 1500ms infinite linear;
  -moz-animation: dtb-spinner 1500ms infinite linear;
}
</style>
